module.exports = __webpack_public_path__ + "img/Final_rule.3431ab18.png";